import { error, finish } from '../../../modules/ladders/actions/copySportLadder';
import api from '../../../api';

export function request(dispatch, { target, sport }) {
    api.post(`/ladders/copy/${target}/${sport}`, {}, { cache: true }).then(
        ladder => dispatch(finish(target, ladder)),
        ({ errors }) => dispatch(error(target, errors))
    );
}
